import { render, staticRenderFns } from "./Applicationprofile.vue?vue&type=template&id=8bb8b240&scoped=true&"
import script from "./Applicationprofile.vue?vue&type=script&lang=js&"
export * from "./Applicationprofile.vue?vue&type=script&lang=js&"
import style0 from "./Applicationprofile.vue?vue&type=style&index=0&id=8bb8b240&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bb8b240",
  null
  
)

export default component.exports